import React from "react";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import { MuiInput } from "../../components/basicComponent/MuiInput";

const UpdateAgencyBalance = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Update Agency Balance</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Branch Name"
                          placeholder={"Branch Name"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Agency Name "
                          placeholder={"Agency Name "}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Account Type"
                          placeholder={"Account Type"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label="Credit Type"
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          placeholder={"Credit Type"}
                          options={[]}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Requested By"}
                          placeholder="Requested By"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Entered By"}
                          placeholder="Entered By"
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <MuiInput
                          label="Amount "
                          placeholder={"Amount "}
                          value={""}
                        />
                      </div>

                      <div className="col-md-4  mt-3">
                        <MuiDropDown
                          label="Remarks"
                          placeholder={"Remarks"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Submit"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card mt-2 shadow-sm" style={{ maxWidth: 400 }}>
                  <div className="card-body">
                    <h5 className="card-title pb-2 border-bottom  fw-bold">
                      Agent Balance
                    </h5>
                    <div className="d-flex justify-content-between">
                      <span>Credit Limit</span>
                      <span className="fw-semibold">Rs.0</span>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <span>Credit Balance</span>
                      <span className="fw-semibold">Rs.0</span>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <span>Credit Outstanding</span>
                      <span className="fw-semibold">Rs.0</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default UpdateAgencyBalance;
